export default __webpack_public_path__ + "static/media/CNo.65-3.803a36e9.jpg";